import CustomHeroSection from '#/components/common/CustomHeroSection'
import PlansSection from '#/features/plans/components/PlansSection'
import PageTransition from '#/components/common/PageTransition'

export default function AllPlansPage() {
  return (
    <PageTransition>
      <main className="relative flex flex-col bg-primary-50">
        <CustomHeroSection
          title="Flexible Plans"
          breadcrumbLabel="Plans"
          gradientBackground="primary-gradient"
        />

        <PlansSection />
      </main>
    </PageTransition>
  )
}
